'use strict';

module.exports = function decode(data, o) {};